import { z } from 'zod';
import { unitsOfMeasurementSchema } from '../../routing-profile-service/schemas/units-of-measurement.schema';
import { vehicleTypeSchema } from '../../routing-profile-service/schemas/vehicle-type.schema';
import { activitiesSchema } from './activities.schema';
import { assetTypeSchema } from './asset-type.schema';
import { dataVersionSchema } from './data-version.schema';

export const companySettingsSchema = z.object({
  activities: activitiesSchema,
  allowTripCreationByDriver: z.boolean(),
  allowedVehicleTypes: z.array(vehicleTypeSchema).nullable(),
  automaticInvitation: z.boolean(),
  dataVersion: dataVersionSchema.nullable(),
  expirationDate: z.string().nullable(),
  isConfigurationProfileEnabled: z.boolean(),
  isFastestRoutingTypeEnabled: z.boolean(),
  isFleetPortalEnabled: z.boolean(),
  isMapsetsEnabled: z.boolean(),
  isRoutingProfileEnabled: z.boolean(),
  isUnitConversionEnabled: z.boolean(),
  modifiedOn: z.string().nullable(),
  partnerIntegrationSync: z.boolean(),
  shareDataAnonymously: z.boolean(),
  shareTripData: z.boolean(),
  units: unitsOfMeasurementSchema,
  userType: assetTypeSchema,
});

export type CompanySettings = z.infer<typeof companySettingsSchema>;
